import Type from "./types";
import {
  downloadAttachment,
  getImageBlob,
  getwebid
} from "./../services/api.js";
import { Message } from "element-ui";

export const setSort = ({ commit }, data) => {
  commit(Type["SORT"], data);
};
export const setStruct = ({ commit }, data) => {
  commit(Type["STRUCT"], data);
};
export const setStartTime = ({ commit }, data) => {
  commit(Type["STARTTIME"], data);
};
export const setEndTime = ({ commit }, data) => {
  commit(Type["ENDTIME"], data);
};

export const haha = ({ commit, dispatch }, data) => {
  console.log("调用了这里", data);
};
export const setExample = ({ commit, dispatch }, data) => {
  dispatch("haha", data);
  commit(Type["EXAMPLE"], data);
};
// 设置当前频道的信息
export const setCurModelInfo = ({ commit }, data) => {
  commit(Type["CURRENT_MODEL_INFO"], data);
};
// 写入所有频道信息
export const setModelsInfo = ({ commit }, data) => {
  commit(Type["MODELS_INFO"], data);
};
// 设置网站拥有的模块
export const setWebModels = ({ commit }, data) => {
  commit(Type["WEB_MODELS"], data);
};
// 设置当前进入的专题
export const setCurSpecial = ({ commit }, data) => {
  commit(Type["CUR_SPECIAL"], data);
};
export const setActiveChanelIndex = ({ commit }, data) => {
  commit(Type["ACTIVE_CHANEL_INDEX"], data);
};
export const setLogoSrc = ({ commit }, data) => {
  commit(Type["LOGO_SRC"], data);
};
export const setLoginSign = ({ commit }, data) => {
  let d = sessionStorage.getItem("user") ? true : false;
  commit(Type["LOGIN_SUCCESS"], d);
};

//设置webid
export const setWebId = ({ commit }, data) => {
  getwebid(data).then(resul => {
    if (resul) {
      commit(Type["WEB_ID"], resul.data);
    } else {
      commit(Type["WEB_ID"], "1");
    }
  });
};
export const setHideFooter = ({ commit }, data) => {
  if (
    data.includes("ctnews") ||
    data.includes("39.97.23.148") ||
    data.includes("zjkda")
  ) {
    commit(Type["HIDE_FOOTER"], false);
  } else {
    commit(Type["HIDE_FOOTER"], true);
  }
};

// 单张下载
export const aloneDownload = ({ commit }, data) => {
  downloadAttachment(data).then(res => {
    if (res.status_code == 1) {
      let a = document.createElement("a");

      let mimeTypeStr = res.data.data.orgPath;
      var key = mimeTypeStr.lastIndexOf(".");
      var mimeType = mimeTypeStr.substr(key + 1);

      a.href = res.data.data.url;
      a.target = "_blank";

      a.download = data.assetId + "." + mimeType;

      a.click();
      // getImageBlob(res.data.data.url).then(blob => {
      //     let url = URL.createObjectURL(blob);
      //     let a = document.createElement("a");
      //     a.href = url;
      //     a.download = data.assetId + '.' + blob.type.split('/')[1];
      //     a.click();
      // })
    } else {
      Message.error(res.data);
    }
  });
};

export const setisGaonS = ({ commit }, data) => {
  let url = window.location.href.split("/");
  //dam.ihep.ac.cn 高能所  test.saas.vcg.com
  if (
    url[2] == "202.38.128.54" ||
    url[2] == "202.38.128.55" ||
    url[2] == "dam.ihep.ac.cn" ||
    url[2] == "view.vcg.com" ||
    url[2] == "localhost:8081" ||
    url[2] == "saas.vcg.com"
  ) {
    commit(Type["IS_GAONS"], true);
  } else {
    commit(Type["IS_GAONS"], false);
  }
};
export const setisEnglish = ({ commit }, data) => {
  if (data) {
    commit(Type["IS_ENGLISH"], true);
  } else {
    commit(Type["IS_ENGLISH"], false);
  }
};
export const setArea_action = ({ commit }, data) => {
  commit(Type["setArea_mutations"], data);
};
export const setCountry_action = ({ commit }, data) => {
  commit(Type["setCountry_mutations"], data);
};
export const setCity_action = ({ commit }, data) => {
  commit(Type["setCity_mutations"], data);
};



// WEBPACK FOOTER //
// ./src/store/actions.js